module.exports = __webpack_public_path__ + "img/hide-store.12dd131c.svg";